module.exports = __webpack_public_path__ + "static/media/imagenArticle2.0dcb93bd.jpg";